import { combineReducers } from 'redux';

import * as types from './constants';
import * as paymentTypes from '../payment/constants';
import * as tippingTypes from '../tipping/constants';
import * as terminalTypes from '../../terminal/constants';
import { HIDE_RECEIPT } from '../../customer/receipts/constants';

const readers = (state = [], { type, payload }) => {
  switch (type) {
    case types.SELECT_READER:
      return payload;
    case types.SELECT_READER_DONE:
    case types.SELECT_READER_CANCEL:
    case types.NO_AVAILABLE_READERS:
    case types.READER_CONNECT_SUCCESS:
      return [];
    default:
      return state;
  }
};

const cancellable = (state = false, { type, isApiReader }) => {
  switch (type) {
    case tippingTypes.TIPPING_DONE:
    case paymentTypes.CREATE_WEBREADER_TRANSACTION:
      return true;
    case terminalTypes.COLLECT_PAYMENT_METHOD_SUCCESS:
      return isApiReader || false;
    case terminalTypes.PROCESS_PAYMENT_SUCCESS:
    case terminalTypes.READER_TRANSACTION_FAIL:
    case terminalTypes.READER_REFUND_FAIL:
    case terminalTypes.READER_REFUND_SUCCESS:
    case terminalTypes.CANCEL_TRANSACTION:
      return false;
    default:
      return state;
  }
};

const showSelectReaderModal = (state = false, { type }) => {
  switch (type) {
    case types.NO_AVAILABLE_READERS:
    case types.SELECT_READER:
      return true;
    case types.SELECT_READER_DONE:
    case types.SELECT_READER_CANCEL:
    case types.READER_CONNECT_SUCCESS:
      return false;
    default:
      return state;
  }
};

const selectedReader = (state = null, { type, payload }) => {
  switch (type) {
    case types.SELECT_READER_DONE:
      return payload;
    case terminalTypes.COLLECT_PAYMENT_METHOD_SUCCESS:
    case terminalTypes.READER_TRANSACTION_FAIL:
    case terminalTypes.CANCEL_TRANSACTION:
    case types.SELECT_READER_CANCEL:
      return null;
    default:
      return state;
  }
};

const stage = (state = null, { type }) => {
  switch (type) {
    case types.DISCOVER_READERS:
      return 'discover';
    case types.SELECT_READER:
      return 'select';
    case types.SELECT_READER_DONE:
      return 'connect';
    case types.READER_CONNECT_SUCCESS:
      return 'connected';
    case paymentTypes.RESET:
    case types.NO_AVAILABLE_READERS:
    case types.SELECT_READER_CANCEL:
    case terminalTypes.READER_TRANSACTION_FAIL:
    case terminalTypes.READER_TRANSACTION_SUCCESS:
    case terminalTypes.READER_REFUND_FAIL:
    case terminalTypes.READER_REFUND_SUCCESS:
      return null;
    default:
      return state;
  }
};

const paymentStatus = (state = null, { type, payload }) => {
  switch (type) {
    case types.PAYMENT_STATUS_CHANGE:
      return payload;
    case paymentTypes.RESET:
    case types.READER_CONNECT_SUCCESS:
    case terminalTypes.READER_TRANSACTION_FAIL:
    case terminalTypes.READER_TRANSACTION_SUCCESS:
    case terminalTypes.READER_REFUND_FAIL:
    case terminalTypes.READER_REFUND_SUCCESS:
      return null;
    default:
      return state;
  }
};

const webreaderStrategy = (state = null, { type, strategy = null }) => {
  switch (type) {
    case types.DISCOVER_READERS:
    case types.SET_EXTERNAL_PAYMENT_INFO:
      return strategy;
    case paymentTypes.RESET:
    case terminalTypes.READER_TRANSACTION_FAIL:
    case terminalTypes.READER_TRANSACTION_SUCCESS:
    case terminalTypes.READER_REFUND_FAIL:
    case terminalTypes.READER_REFUND_SUCCESS:
    case terminalTypes.CANCEL_TRANSACTION:
    case types.SELECT_READER_CANCEL:
      return null;
    default:
      return state;
  }
};

// indicator for processing payment intents in webview
const isProcessingExternalPayment = (state = false, { type }) => {
  switch (type) {
    case paymentTypes.CREATE_WEBREADER_TRANSACTION:
      return true;
    case paymentTypes.RESET:
    case terminalTypes.CANCEL_TRANSACTION:
    case terminalTypes.READER_TRANSACTION_FAIL:
    case terminalTypes.READER_TRANSACTION_SUCCESS:
      return false;
    default:
      return state;
  }
};

const externalPayment = (state = null, { type, payload }) => {
  switch (type) {
    case types.SET_EXTERNAL_PAYMENT_INFO:
      return payload;
    case types.SELECT_READER_CANCEL:
      return null;
    default:
      return state;
  }
};

/**
 * @description
 * When tipping on reader, checkout endpoint doesn't have information about the tip amount and has improper totals.
 * The only way to get the tip amount is to use the response from the capture endpoint which has the same structure.
 */
const readerIntentCaptureResult = (state = null, { type, payload }) => {
  switch (type) {
    case HIDE_RECEIPT:
    case terminalTypes.READER_TRANSACTION_FAIL:
    case terminalTypes.CANCEL_TRANSACTION:
    case types.SELECT_READER_CANCEL:
      return null;
    case terminalTypes.READER_TRANSACTION_SUCCESS:
      return payload;
    default:
      return state;
  }
};

const webReaderReducer = combineReducers({
  readers,
  showSelectReaderModal,
  cancellable,
  selectedReader,
  stage,
  paymentStatus,
  isProcessingExternalPayment,
  externalPayment,
  webreaderStrategy,
  readerIntentCaptureResult,
});

export default webReaderReducer;
